import filter from 'lodash-es/filter';

/**
 * Typical usage:
 * bestMatch(products, {color : 123, size:789}, i => i.data)
 */
export function bestMatch<T, K>(collection: T[], properties: Partial<K>, extractor?: (item: T) => Partial<K>): T {
    let bestMatchScore = 0;
    let bestMatchingItem = collection[0];
    const maxScore = Object.keys(properties).length;
    collection.find(item => {
        const itemData = extractor ? extractor(item) : item;
        // calc number of matching of fields for every element
        const score = filter(properties as any, (value, key) => itemData[key] === value).length;
        if (score > bestMatchScore) {
            bestMatchingItem = item;
            bestMatchScore = score;
        }
        // keep looking unless perfect match
        return bestMatchScore >= maxScore;
    });

    return bestMatchingItem;
}
